import { NSARouterMakerResult } from "namirasoft-account-react";
import { FiscalYearFullRow, FiscalYearInputRow, FiscalYearRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxDate, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { FiscalYearBranchesView } from "../components/FiscalYearBranchesView";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class FiscalYearEditPage extends Component<Props>
{
    Name = createRef<NSBoxString>();
    DateStart = createRef<NSBoxDate>();
    DateEnd = createRef<NSBoxDate>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        return (
            <ErpLayout<FiscalYearRow, FiscalYearInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.fiscal_year(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): FiscalYearInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        date_start: this.DateStart.current?.getValue()?.toISOString() ?? "",
                                        date_end: this.DateEnd.current?.getValue()?.toISOString() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        fiscal_year_category: [],
                                        fiscal_year_tag: [],
                                        fiscal_year_field: [],
                                    }),
                                    setRow: (row: FiscalYearRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id });
                                        this.Name.current?.setValue(row.name);
                                        this.DateStart.current?.setValue(row.date_start ? new Date(row.date_start) : null);
                                        this.DateEnd.current?.setValue(row.date_end ? new Date(row.date_end) : null);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            },
                            getChildrenAfter: (id, row) =>
                            {
                                if (!row || !id)
                                    return null;
                                let row_full = row as FiscalYearFullRow;
                                return (
                                    <FiscalYearBranchesView
                                        {...this.props}
                                        fiscal_year_id={id}
                                        rows={row_full.branches}
                                    />
                                );
                            },
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/fiscal-year/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxDate ref={this.DateStart} required title="Date Start" info={{ link: "https://namirasoft.com/erp/console-guide/fiscal-year/#field-date-start" }} style={{ width: NSBox.width.double }} />
                    <NSBoxDate ref={this.DateEnd} required title="Date End" info={{ link: "https://namirasoft.com/erp/console-guide/fiscal-year/#field-date-end" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/fiscal-year/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/fiscal-year/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}